import React from "react";
import styles from "./SportsmanCard.module.styl";
import { exact, PropTypes } from "prop-types";
import { useHistory } from "react-router";
import { Avatar, Subtitle } from "uikit/components";
import Moment from "moment";
import { getPluralFormOfYear } from "utils";

export default function SportsmanCard({ sportsman, index }) {
    let age = null;
    if (sportsman.birthDate) {
        const birthDate = Moment(sportsman.birthDate);
        const year = Moment(new Date()).diff(birthDate, "years");
        age = `${year} ${getPluralFormOfYear(year)}`;
    }

    const history = useHistory();

    const goTo = function () {
        history.push({
            pathname: `sportsman/${sportsman.id}`,
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles.index}>{index}.</div>
            <div className={styles.avatar}>
                <Avatar
                    size={"medium"}
                    shape={"circle"}
                    uri={sportsman.avatarUrl}
                    sex={sportsman.sex}
                    background={"grey"}
                />
            </div>
            <div className={styles.info}>
                <div className={styles.title} onClick={goTo}>
                    <Subtitle size={"subtitle-2"}>{sportsman.name}</Subtitle>
                </div>
                <Subtitle size={"subtitle-2"}>
                    {age ? age + ", " : ""}
                    {sportsman.sportType}, {sportsman.trainingLevel}
                </Subtitle>
            </div>
            <div className={styles.rfPosition}>
                <Subtitle size={"subtitle-2"}>{sportsman.rfPosition}</Subtitle>
            </div>
            <div className={styles.regionPosition}>
                <Subtitle size={"subtitle-2"}>{sportsman.regionPosition}</Subtitle>
            </div>
            <div className={styles.schoolPosition}>
                <Subtitle size={"subtitle-2"}>{sportsman.schoolPosition}</Subtitle>
            </div>
            <div className={styles.rating}>
                <Subtitle size={"subtitle-2"}>{sportsman.rating}%</Subtitle>
            </div>
        </div>
    );
}

SportsmanCard.propTypes = {
    sportsman: exact({
        id: PropTypes.number.isRequired,
        avatarUrl: PropTypes.string,
        sex: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        birthDate: PropTypes.string,
        sportType: PropTypes.string.isRequired,
        trainingLevel: PropTypes.string.isRequired,
        regionPosition: PropTypes.number.isRequired,
        rfPosition: PropTypes.number.isRequired,
        schoolPosition: PropTypes.number.isRequired,
        rating: PropTypes.number.isRequired,
    }).isRequired,
    index: PropTypes.number.isRequired,
};
